__webpack_require__.p = "https://certificate.quantstamp.com/full/telescope/ff6b5a19-2c2e-48c1-a5c7-f911d78c50f6/";